import React from "react"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { connect } from "react-redux"
import { CSSTransition, SwitchTransition } from "react-transition-group"
import { confirmAlert } from "react-confirm-alert"
import {
  saveCommunityActivities,
  saveMyGoals,
  deleteRequiredServices
} from "../../../../services/plans"
import "./styles.scss"

import Header from "../../../../components/Header"
import Footer from "../../../../components/Footer"
import PlanDetails from "./components/PlanDetails"
import MyGoals from "./components/MyGoals"
import RequiredServices from "./components/RequiredServices"
import Suggestions from "./components/Suggestions"
import Notifications from "../../../../components/Notifications"
import Button from "../../../../components/Button"

class MyPlan extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      tabIndex: 0,
      tabState: true,
      tabsNav: [
        {
          id: "plan-details",
          title: "Plan Details",
          index: 0
        },
        {
          id: "my-goals",
          title: "My Goals",
          index: 1
        },
        {
          id: "required-services",
          title: "Required Services",
          index: 2
        },
        {
          id: "suggestions",
          title: "Suggestions",
          index: 3
        }
      ]
    }
  }

  componentDidMount() {
    this.changeUrl()
  }

  componentDidUpdate(prevProps) {
    const { computedMatch } = this.props

    if (prevProps.computedMatch.params.tab !== computedMatch.params.tab) {
      this.changeUrl()
    }
  }

  changeTab = (e, index) => {
    e.preventDefault()
    const { tabState, tabIndex } = this.state

    if (tabIndex !== index) {
      this.setState({ tabIndex: index, tabState: !tabState })
    }
  }

  removeCommunityActivities = index => {
    const {
      onSaveCommunityActivities,
      store: { user, plan }
    } = this.props

    const newCommunityActivities = plan.answers.communityActivities.filter(
      item => {
        const communityActivitie = item

        if (item.id === index) {
          return false
        }

        return communityActivitie
      }
    )

    onSaveCommunityActivities(user.token, plan.id, newCommunityActivities)
  }

  removeMyGoals = index => {
    const {
      onSaveMyGoals,
      store: { user, plan }
    } = this.props

    const newGoals = plan.answers.myGoals.goal.filter(item => {
      const goal = item

      if (item.id === index) {
        return false
      }

      return goal
    })

    onSaveMyGoals(user.token, plan.id, newGoals)
  }

  removeRequiredServices = id => {
    const {
      onDeleteRequiredServices,
      store: { user, plan }
    } = this.props

    const deleteItem = () => {
      onDeleteRequiredServices(user.token, plan.id, id)
    }

    confirmAlert({
      title: "Are you sure?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            deleteItem()
          }
        },
        {
          label: "No"
        }
      ]
    })
  }

  changeUrl() {
    const {
      computedMatch: { params }
    } = this.props
    const { tabsNav } = this.state

    if (params.tab) {
      const result = tabsNav.find(item => {
        return item.id === params.tab
      })

      if (result) {
        this.setState({ tabIndex: result.index })
      }
    }
  }

  render() {
    const {
      notifications,
      store: { plan }
    } = this.props
    const { tabIndex, tabState, tabsNav } = this.state

    const planStatus = !!plan.id

    return (
      <div className="main-container main-container--light">
        <Header theme="dark" />

        <div className="content my-plan">
          <div
            className={`content_section_header ${notifications &&
              "content_section_header--dark"}`}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-10 offset-md-1">
                  <h1 className="content_section_title">
                    My Plan Dashboard
                    {planStatus && (
                      <Button
                        routerLink={{ to: "/pre-plan/support-team" }}
                        className="btn--secondary-light btn--width-lg btn--height-lg"
                      >
                        Continue editing my pre-plan
                      </Button>
                    )}
                  </h1>
                </div>
              </div>
            </div>
            <Notifications />
          </div>
          <>
            {plan.loading ? (
              <Loader
                type="TailSpin"
                color="#0c4632"
                height={80}
                width={80}
                className="loader"
              />
            ) : (
              <div className="container">
                <div className="tabs">
                  <nav className="tabs_list">
                    <ul>
                      {tabsNav.map(({ id, title, index }) => (
                        <li key={id}>
                          <a
                            href="/#"
                            className={tabIndex === index ? "selected" : ""}
                            onClick={e => {
                              this.changeTab(e, index)
                            }}
                          >
                            {title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </nav>

                  <div className="tabs_content">
                    <SwitchTransition>
                      <CSSTransition
                        timeout={300}
                        key={tabState}
                        classNames="slide"
                      >
                        {(() => {
                          switch (tabIndex) {
                            case 0:
                              return (
                                <PlanDetails
                                  aboutMe={plan.answers.aboutMe}
                                  supportTeam={plan.answers.supportTeam}
                                  communityActivities={
                                    plan.answers.communityActivities
                                  }
                                  removeCommunityActivities={
                                    this.removeCommunityActivities
                                  }
                                />
                              )
                            case 1:
                              return (
                                <MyGoals
                                  goals={plan.answers.myGoals}
                                  removeMyGoals={this.removeMyGoals}
                                />
                              )
                            case 2:
                              return (
                                <RequiredServices
                                  requiredServices={
                                    plan.answers.requiredServices
                                  }
                                  goals={plan.answers.myGoals}
                                  removeItem={this.removeRequiredServices}
                                />
                              )
                            case 3:
                              return <Suggestions />
                            default:
                              return null
                          }
                        })()}
                      </CSSTransition>
                    </SwitchTransition>
                  </div>
                </div>
              </div>
            )}
          </>
        </div>
        <Footer />
      </div>
    )
  }
}

MyPlan.propTypes = {
  notifications: propTypes.bool,
  onSaveCommunityActivities: propTypes.func.isRequired,
  onSaveMyGoals: propTypes.func.isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        aboutMe: propTypes.shape({}),
        supportTeam: propTypes.arrayOf(
          propTypes.shape({
            id: propTypes.string,
            first_name: propTypes.string,
            last_name: propTypes.string,
            email: propTypes.string,
            phone: propTypes.string,
            relationship: propTypes.shape({
              relationship: propTypes.string,
              support_provided: propTypes.string
            })
          })
        ),
        communityActivities: propTypes.arrayOf(
          propTypes.shape({
            id: propTypes.string,
            title: propTypes.string,
            content: propTypes.string
          })
        ),
        myGoals: propTypes.shape({
          goal: propTypes.arrayOf(propTypes.shape({}))
        }),
        requiredServices: propTypes.arrayOf(propTypes.shape({}))
      })
    })
  }).isRequired,
  computedMatch: propTypes.shape({
    params: propTypes.shape({
      tab: propTypes.string
    })
  }).isRequired,
  onDeleteRequiredServices: propTypes.func.isRequired
}

MyPlan.defaultProps = {
  notifications: false
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveCommunityActivities: (token, planId, activities) =>
    dispatch(saveCommunityActivities(token, planId, activities)),
  onSaveMyGoals: (token, planId, goals) =>
    dispatch(saveMyGoals(token, planId, goals)),
  onDeleteRequiredServices: (token, planId, serviceId) =>
    dispatch(deleteRequiredServices(token, planId, serviceId))
})

export default connect(mapStateToProps, mapDispatchToProps)(MyPlan)
